import Vue from 'vue'
import VueRouter from 'vue-router'

import TeacherView from '../views/TeacherView.vue'
import ShareView from '../views/ShareView.vue'
import TrainerView from '../views/TrainerView.vue'
import StudentView from '../views/StudentView.vue'

import LessonsView from '../components/teacher/LessonsView.vue'
import TrainingView from '../components/teacher/TrainingView.vue'
import TrainerTrainingView from '../components/trainer/TrainingView.vue'
import EventsView from '../components/trainer/EventsView.vue'
import SendLink from '../components/SendLink.vue'

Vue.use(VueRouter)

const routes = [
    {path: '/',
     component: SendLink,
     meta: { title: 'Usumu' }},
    {path: '/error/unauthorized',
     component: SendLink,
     props: {
         error_code: 401
     },
     meta: { title: '401 - Unauthorized' }},
    {path: '/error/notfound',
     component: SendLink,
     props: {
     error_code: 404
     },
     meta: { title: '404 - Not Found' }},
    {path: '/teacher',
     component: TeacherView,
     children: [
        {path: 'lessons/:hash([0-9a-f]{64})', meta: { title: 'Lessons'}, component: LessonsView, alias: ':hash([0-9a-f]{64})'},
        {path: 'training/:hash([0-9a-f]{64})', meta: { title: 'Training'}, component: TrainingView},
        {path: '*', redirect: '/error/notfound'}
    ]},
    {path: '/view/:token([0-9a-zA-Z_\\-\\.]{32,256})',
     component: ShareView,
     meta: { title: 'Lessons'}},
    {path: '/trainer',
     component: TrainerView,
     children: [
         {path: 'training/:hash([0-9a-f]{64})', meta: { title: 'Training'}, component: TrainerTrainingView, alias: ':hash([0-9a-f]{64})'},
         {path: 'events/:hash([0-9a-f]{64})', meta: { title: 'Events'}, component: EventsView},
         {path: '*', redirect: '/error/notfound'}
    ]},
    {path: '/student',
     component: StudentView,
     children: [
        {path: ':hash([0-9a-f]{64})', meta: {title: 'Timetable'}},
        {path: '*', redirect: '/error/notfound'}
    ]},
    {path: '/anleitung',
     redirect: () => {window.location = '/anleitung.pdf'}},
    {path: '/umfrage',
     redirect: () => {window.location = 'https://docs.google.com/forms/d/e/1FAIpQLSdcqUqFkWqtf9XmWzGG7BmM1p507a3rw4Rsz4tbtAZ0tSHORg/viewform?usp=sf_link'}},
    {path: '*',
     redirect: '/error/notfound'}
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

export default router
